import ErrorAlert from './error_alert'

function LoadingSpinner({ message = "Loading..." }) {
  return (
    <div className="tw-flex tw-justify-center tw-items-center tw-py-8">
      <span className="tw-loading tw-loading-spinner tw-loading-lg"></span>
      <span className="tw-ml-2">{message}</span>
    </div>
  );
}

function EmptyState({
  title,
  subtitle,
  actionButton,
  icon
}) {
  return (
    <div className="tw-text-center tw-py-8">
      {icon && <div className="tw-mb-4">{icon}</div>}
      <p className="tw-text-gray-500 tw-mb-2">{title}</p>
      {subtitle && <p className="tw-text-sm tw-text-gray-400 tw-mb-4">{subtitle}</p>}
      {actionButton}
    </div>
  );
}

export default function DataTable({
  data = [],
  columns = [],
  isLoading = false,
  error = null,
  onRetry,
  emptyStateConfig = {},
  tableClassName = "tw-w-full"
}) {
  if (isLoading) {
    return <LoadingSpinner message={emptyStateConfig.loadingMessage || "Loading data..."} />;
  }

  if (error) {
    return <ErrorAlert error={error} onRetry={onRetry} />;
  }

  if (!data || data.length === 0) {
    return (
      <EmptyState
        title={emptyStateConfig.title || "No records found"}
        subtitle={emptyStateConfig.subtitle}
        actionButton={emptyStateConfig.actionButton}
        icon={emptyStateConfig.icon}
      />
    );
  }

  return (
    <div className="tw-overflow-auto">
      <table className={`tw-table-auto ${tableClassName} tw-mb-4 tw-border tw-border-gray-300`}>
        <thead>
          <tr>
            {columns.map((column) => (
              <th
                key={column.id}
                className="tw-px-4 tw-py-2 tw-text-center tw-border tw-border-gray-300"
                style={column.size ? { width: column.size } : {}}
              >
                {column.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {columns.map((column) => (
                <td 
                  key={column.id}
                  className="tw-px-4 tw-py-2 tw-text-sm tw-border tw-border-gray-300"
                  style={column.size ? { width: column.size } : {}}
                >
                  {column.Cell
                    ? column.Cell({ cell: { getValue: () => row[column.accessorKey] }, row })
                    : row[column.accessorKey]
                  }
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
